// extracted by mini-css-extract-plugin
export default {"container":"con_2whSW","input":"con_inp_Ofd4w","phoneSelector":"con_pho_2RtLF","dialCode":"con_dia_nMtMD","tel":"con_tel_7XpYX"};